/*******************************************************************
* PAGE        : sessionConfig
* REMARKS     : Shared session timeout constant used by useSessionTimeout
*               (expires an active session) and useRestoreSession
*               (decides whether a stored session is still eligible for
*               auto-login in a new tab/window)
* CREATED ON  : 29-09-2026
* AUTHOR      : Bamroliya.Paras
********************************************************************/

export const SESSION_TIMEOUT_MS = 8 * 60 * 60 * 1000; // 8 hours
